import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import { logout } from '../../utils/auth';
import NotificationCenter from '../NotificationCenter';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigationItems = [
    { label: 'Dashboard', path: '/dashboard', icon: 'LayoutDashboard' },
    { label: 'Bomkalkulator', path: '/toll-calculator', icon: 'Calculator' },
    { label: 'Historikk', path: '/toll-history', icon: 'History' },
    { label: 'Min Konto', path: '/subscription-portal', icon: 'User' },
    { label: 'Kontakt', path: '/contact', icon: 'MessageSquare' },
  ];

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  const handleLogout = () => {
    logout(navigate);
    setIsMobileMenuOpen(false);
  };

  const isActive = (path) => location?.pathname === path;

  return (
    <>
      <button
        className="mobile-menu-button"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        aria-label="Toggle navigation menu"
        aria-expanded={isMobileMenuOpen}
      >
        <Icon
          name={isMobileMenuOpen ? 'X' : 'Menu'}
          size={24}
          color="var(--color-foreground)"
        />
      </button>
      <header className="nav-header">
        <div className="flex items-center justify-between h-full max-w-[1440px] mx-auto">
          <div className="nav-header-logo">
            <div className="nav-header-brand">
              <Icon name="Navigation" size={24} color="var(--color-primary)" />
            </div>
            <span className="nav-header-text hidden sm:block">Veiassistent</span>
          </div>

          <nav className="hidden lg:flex items-center gap-2" aria-label="Primary navigation">
            {navigationItems?.map((item) => (
              <button
                key={item?.path}
                onClick={() => handleNavigation(item?.path)}
                className={`nav-link ${isActive(item?.path) ? 'active' : ''}`}
                aria-current={isActive(item?.path) ? 'page' : undefined}
              >
                <span className="flex items-center gap-2">
                  <Icon name={item?.icon} size={18} />
                  {item?.label}
                </span>
              </button>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-4">
            <NotificationCenter />
            <button
              onClick={() => navigate('/trust-and-security')}
              className={`nav-link ${isActive('/trust-and-security') ? 'active' : ''}`}
              aria-label="Trust and security settings"
              aria-current={isActive('/trust-and-security') ? 'page' : undefined}
            >
              <Icon name="Shield" size={18} />
            </button>
            <button
              onClick={handleLogout}
              className="nav-link"
              aria-label="Logg ut"
              style={{ display: 'flex', alignItems: 'center', gap: '6px', color: 'var(--color-muted-foreground)', transition: 'color 150ms ease-out' }}
              onMouseEnter={e => e.currentTarget.style.color = '#EF4444'}
              onMouseLeave={e => e.currentTarget.style.color = 'var(--color-muted-foreground)'}
            >
              <Icon name="LogOut" size={18} />
              <span style={{ fontFamily: 'var(--font-caption)', fontSize: '13px', fontWeight: 500 }}>Logg ut</span>
            </button>
          </div>
        </div>
      </header>
      {isMobileMenuOpen && (
        <div className="mobile-menu-overlay">
          <nav aria-label="Mobile navigation">
            {navigationItems?.map((item) => (
              <button
                key={item?.path}
                onClick={() => handleNavigation(item?.path)}
                className={`mobile-nav-link ${isActive(item?.path) ? 'active' : ''}`}
                aria-current={isActive(item?.path) ? 'page' : undefined}
              >
                <span className="flex items-center gap-3">
                  <Icon name={item?.icon} size={24} />
                  {item?.label}
                </span>
              </button>
            ))}
            <button
              onClick={() => handleNavigation('/trust-and-security')}
              className="mobile-nav-link"
            >
              <span className="flex items-center gap-3">
                <Icon name="Shield" size={24} />
                Sikkerhet
              </span>
            </button>
            <button
              onClick={handleLogout}
              className="mobile-nav-link"
              style={{ color: '#EF4444' }}
            >
              <span className="flex items-center gap-3">
                <Icon name="LogOut" size={24} />
                Logg ut
              </span>
            </button>
          </nav>
        </div>
      )}
    </>
  );
};

export default Header;